export default __webpack_public_path__ + "static/media/vBnb.47f69f11.svg";